import {NavLink} from 'react-router-dom';

export const NavigationElement = ({title, Icon, path, onClick}) => {
    return (
        <NavLink
            to={path}
            className={({isActive}) => `navigation-element ${isActive ? 'is-active' : ''}`}
            onClick={onClick}
        >
            <Icon className="wallet-icon"/>
            <span className="navigation-element__title">{title}</span>
        </NavLink>
    );
};